import { Box, Skeleton, Stack } from '@mui/material';

const skeletonSx = {
  animation: 'skeletonPulse 1.5s ease-in-out infinite',
  '@keyframes skeletonPulse': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.5 },
  },
};

/**
 * Skeleton pour les pages du tableau de bord (liste d’articles, utilisateurs, etc.).
 * Affiche un en-tête, une barre de recherche et soit une grille de cartes soit un tableau.
 */
export function DashboardPageSkeleton({ variant = 'cards' }) {
  return (
    <Box
      sx={{
        width: '100%',
        animation: 'skeletonFadeIn 0.3s ease-out',
        '@keyframes skeletonFadeIn': {
          from: { opacity: 0 },
          to: { opacity: 1 },
        },
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2} sx={{ mb: 3 }}>
        <Box>
          <Skeleton variant="text" width={220} height={40} sx={{ mb: 0.5, ...skeletonSx }} animation="wave" />
          <Skeleton variant="text" width={320} height={24} sx={skeletonSx} animation="wave" />
        </Box>
        <Skeleton variant="rounded" width={160} height={40} sx={skeletonSx} animation="wave" />
      </Stack>
      <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} variant="rounded" sx={{ flex: 1, height: 80, ...skeletonSx }} animation="wave" />
        ))}
      </Stack>
      <Skeleton variant="rounded" width="100%" height={48} sx={{ maxWidth: 560, mb: 2, ...skeletonSx }} animation="wave" />
      <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
        <Skeleton variant="rounded" width={80} height={40} sx={skeletonSx} animation="wave" />
        <Skeleton variant="rounded" width={120} height={40} sx={skeletonSx} animation="wave" />
        <Skeleton variant="rounded" width={80} height={40} sx={skeletonSx} animation="wave" />
      </Box>
      {variant === 'cards' ? (
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }, gap: 2 }}>
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <Skeleton key={i} variant="rounded" height={280} sx={{ borderRadius: 2, ...skeletonSx }} animation="wave" />
          ))}
        </Box>
      ) : (
        <Skeleton variant="rounded" height={400} sx={{ borderRadius: 2, ...skeletonSx }} animation="wave" />
      )}
    </Box>
  );
}

/**
 * Skeleton minimal (titre + bloc contenu) pour les pages plus simples.
 */
export function DashboardPageSkeletonMinimal() {
  return (
    <Box sx={{ width: '100%' }}>
      <Skeleton variant="text" width={200} height={44} sx={{ mb: 2, ...skeletonSx }} animation="wave" />
      <Skeleton variant="text" width={280} height={24} sx={{ mb: 3, ...skeletonSx }} animation="wave" />
      <Skeleton variant="rounded" height={320} sx={{ borderRadius: 2, ...skeletonSx }} animation="wave" />
    </Box>
  );
}
